/* eslint-env browser, jquery */

'use strict';

const _ = require('underscore');
const AutoSlideShow = require('./AutoSlideShow');
const Media = require('./Media');

class MediaContainer {
  constructor(data, $el, onLoadAction, postSwapActions) {
    this.data = data;
    this.index = 0;
    this.$mediaWrapper = $el.find('.media-container');
    this.$featuredImg = this.$mediaWrapper.find('img.current-media');
    this.$featuredImg.attr('onload', onLoadAction);
    this.$waitingImages = this.$mediaWrapper.find('.waiting-image');
    this.onBlur = this.onBlur.bind(this);

    if (this.data.showDealPagePhotoFade) {
      this.autoSlideShow = new AutoSlideShow(() => {
        this.handleMediaSwap('incrementIndex');
      }, 4000);
      this.autoSlideShow.enable();
      window.addEventListener('blur', this.onBlur, false);
    }

    this.mediaArray = [];
    this.mediaCount = data.media.length;
    for (let i = 0; i < this.mediaCount; i += 1) {
      this.mediaArray.push(
        new Media(data.media[i], this.$mediaWrapper, this.autoSlideShow)
      );
    }
    this.currentMedia = this.mediaArray[this.index];

    const basePostSwapActions = {
      preload: this.preloadMedia,
    };

    if (this.data.imageZoom) {
      _.extend(basePostSwapActions, {
        setUpZoom: nextMediaObj => this.setUpZoom(nextMediaObj),
      });
    }
    this.basePostSwapActions = _.extend(
      {},
      basePostSwapActions,
      postSwapActions
    );
    this.$zoomMessage = $el.find('.image-zoom-message');
    this.$badging = $el.find('.featured-badge');

    $(window).load(() =>
      this.fetchVideoScripts(
        data.videoScriptUrls,
        $el.find('.video-container, .thumbnail.video')
      )
    );
    /*
      fallback urls use the same image url for thumbnails and main image;
      Safari won't trigger the onload event for <img>
        when new src is the same as the current, loaded source.
    */
    if (data.media[0].fallbackUrls) {
      // use setTimeout so that onload event will happen after DealCarousel returns
      setTimeout(() => this.$featuredImg.trigger('onload'), 0);
    }
  }

  fixHeight(height, width) {
    this.$mediaWrapper.css({ width, height });
    this.$mediaWrapper
      .find('.video-container .video-player')
      .css('height', height);
    this.$mediaWrapper.css('padding-top', 0);
  }

  onLoad() {
    if (this.$mediaWrapper.hasClass('loaded')) {
      return;
    }
    this.$waitingImages.each((index, element) => {
      $(element).attr('src', $(element).attr('data-thumb'));
    });

    this.$mediaWrapper.addClass('loaded');
    this.$featuredImg.css({
      filter: 'blur(0px)',
      '-webkit-filter': 'blur(0px)',
    });
    this.$featuredImg.attr('data-loaded', 'true');
  }

  onBlur() {
    if (document.activeElement instanceof HTMLIFrameElement) {
      if (this.autoSlideShow) {
        this.autoSlideShow.disable();
      }
      window.removeEventListener('blur', this.onBlur, false);
    }
  }

  getActiveId() {
    return this.currentMedia.getId();
  }

  preloadMedia() {
    this.loadMediaAt(this.index - 1);
    this.loadMediaAt(this.index + 1);
  }

  loadMediaAt(index) {
    let adjustedIndex;
    if (index < 0) {
      adjustedIndex = this.mediaCount + index;
    } else if (index >= this.mediaCount) {
      adjustedIndex = 0;
    } else {
      adjustedIndex = index;
    }

    return this.mediaArray[adjustedIndex].load();
  }

  getIndexFromTraits({ selectedTraits }) {
    if (!this.data.hasTraits) {
      return this.index;
    }
    for (let i = 0; i < this.mediaCount; i += 1) {
      if (!this.mediaArray[i].isVideo) {
        const imageTraits = this.mediaArray[i].data.traits;
        if (!imageTraits || imageTraits.length === 0) continue;

        let traitsMatch = true;
        for (const traitName in selectedTraits) {
          const traitValue = selectedTraits[traitName];
          if (
            !imageTraits[traitName] ||
            !_.contains(imageTraits[traitName], traitValue)
          ) {
            traitsMatch = false;
            break;
          }
        }
        if (traitsMatch) {
          return i;
        }
      }
    }
    return 0;
  }

  getIndexByDataId({ dataId }) {
    return _.findIndex(this.mediaArray, media => media.getId() === dataId);
  }

  getMediaByDataId(dataId) {
    return _.find(this.mediaArray, media => media.getId() === dataId);
  }

  incrementIndex() {
    return this.index + 1 === this.mediaCount ? 0 : this.index + 1;
  }

  decrementIndex() {
    return this.index - 1 === -1 ? this.mediaCount - 1 : this.index - 1;
  }

  getTraitsByIndex() {
    return this.mediaArray[this.index].data.traits;
  }

  fetchVideoScripts(videoScriptUrls, $videoEls) {
    if (videoScriptUrls) {
      if (!window.YT && videoScriptUrls.youtubeScriptUrl) {
        $.ajax({
          url: videoScriptUrls.youtubeScriptUrl,
          dataType: 'script',
          fail() {
            $videoEls !== undefined ? $videoEls.remove() : undefined;
          },
        });
      }
    }
  }

  swapMedia(newMediaObj) {
    this.currentMedia.hide();
    newMediaObj.show();
    if (newMediaObj.data.isVideo) {
      this.$badging.hide();
      if (this.autoSlideShow && this.autoSlideShow.isEnabled()) {
        this.autoSlideShow.stop();
      }
    } else {
      this.$badging.show();
    }
    this.currentMedia = newMediaObj;
  }

  setUpZoom(newMediaObj) {
    if (newMediaObj.setUpZoom()) {
      this.$zoomMessage.removeClass('hide-zoom');
    } else {
      this.$zoomMessage.addClass('hide-zoom');
    }
  }

  handleMediaSwap(indexFinder, data = {}, postSwapActions = {}) {
    const newIndex = this[indexFinder](data);
    if (newIndex === this.index || newIndex === undefined || newIndex === -1)
      return;

    const nextMediaObj = this.loadMediaAt(newIndex);
    // bail out of swap if loadMediaAt fails
    if (!nextMediaObj) return;

    this.index = newIndex;
    this.swapMedia(nextMediaObj);

    const actionsHash = _.extend({}, this.basePostSwapActions, postSwapActions);
    const actionNames = Object.keys(actionsHash);

    for (let i = 0; i < actionNames.length; i += 1) {
      const action = actionsHash[actionNames[i]];
      if (action !== undefined) {
        action.call(this, nextMediaObj, data);
      }
    }
  }
}

module.exports = MediaContainer;
